export var gridConfig = {
    originBaseX: 3525,
    originBaseY: 3500,
    tileSizeX: 66,
    tileSizeY: 33,
};



//////////////////
// WEBPACK FOOTER
// ./src/setup/gridConfig.ts
// module id = 808
// module chunks = 3